// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2456":"a9be5ef7f7a43afe","8997":"200d89a2eb27f60b"}[chunkId] + ".css";
};